import {NullDeviceKeyAdapter} from '@vizir-banking/banking-app-core/dist/device-key/adapters/null-device-key-adapter';
import {DeviceKeyAdapter} from '@vizir-banking/banking-app-core/dist/device-key/adapters/device-key-adapter';

export const deviceKeyAdapter: DeviceKeyAdapter = new NullDeviceKeyAdapter();
